(function(){
	"use strict";

	angular
		.module('pwc.controllers')
		.controller('PurchaseDateReportController', PurchaseDateReportController);

	PurchaseDateReportController.$inject = ['$window', 'WineRepository', '$log', 'lodash', '$state'];

	function PurchaseDateReportController($window, WineRepository, $log, lodash, $state){

		/* jshint validthis: true */
		var self = this;

		self.winesByYearMonth = {};

		self.report = {
			loading: true,
			dateFrom: null,
			dateTo: null,
			groups: [],
			totals: {}
		};

		self.currentDate = $window.moment().format('MM/DD/YYYY');

		self.currentYear = $window.moment().format('YYYY');

		self.title = $state.current.data.title;

		self.printSettings = {
			"fontSize": 12,
			"style": "custom"
		};

		self.print = print;
		self.updateDateRange = updateDateRange;
		self.initialize = initialize;

		/** initialize */

		initialize();

		/** begin methods */

		function initialize(){
			// @todo once we upgrade to moment >= 2.11.0
			// isSame || isAfter  can be combined to isSameOrAfter
			// isSame || isBefore can be combined to isSameOrBefore
			// @todo add or unset to always add the purchase:
			// we currently don't by default show all dates which is something I'd think people may want
			if (! self.report.dateFrom || ! self.report.dateTo) {
				// display warning
				self.report.message = 'To begin please choose a date range above';
				// hide loading
				self.report.loading = false;
				return;
			}
			self.report.message = null;

			WineRepository.all()
				.then(function(wineEntities){

					if (wineEntities.length > 0) {

						self.report.tableHeaders = [
							'Wine',
							'Size',
							'Bottles In Cellar / Purchased / On Order',
							'Cost',
							'Value',
							'Gain&nbsp;/&nbsp;Loss'
						];

						// add only those that were purchased
						lodash.forEach(wineEntities, function (wine) {
							var purchases = wine.getPurchaseHistory();

							if (purchases.length > 0) {
								lodash.forEach(purchases, function (purchase) {
									var purchaseDate = $window.moment(purchase.date);

									if (
										(purchaseDate.isSame(self.report.dateFrom) || purchaseDate.isAfter(self.report.dateFrom)) &&
										(purchaseDate.isSame(self.report.dateTo) || purchaseDate.isBefore(self.report.dateTo))
									) {
										var year = $window.moment(purchase.date).format('YYYY');
										var month = $window.moment(purchase.date).format('M');
										var monthName = $window.moment(purchase.date).format('MMMM');

										// create empty obj for year key
										if (typeof self.winesByYearMonth[year] === 'undefined') {
											self.winesByYearMonth[year] = {};
										}

										// create empty array for year.month
										if (typeof self.winesByYearMonth[year][month] === 'undefined') {
											self.winesByYearMonth[year][month] = [];
										}

										self.winesByYearMonth[year][month].push({
											wine: wine,
											purchase: purchase,
											year: year,
											month: month,
											monthName: monthName
										});
									}
								});
							}
						});

						// initialize totals
						var grandTotals = {
							bottlesPurchased: 0,
							cost: 0,
							yearCount: Object.keys(self.winesByYearMonth).length
						};

						if (lodash.size(self.winesByYearMonth) > 0) {
							lodash.forEach(self.winesByYearMonth, function (months, year) {
								var yearTotals = {
									bottlesPurchased: 0,
									cost: 0
								};

								var groupedByMonth = [];

								lodash.forEach(months, function (purchaseObjs, month) {
									var monthTotals = {
										bottlesPurchased: 0,
										cost: 0
									};

									var purchasesThisMonth = [];

									lodash.forEach(purchaseObjs, function (purchaseObj) {
										var varietal = (purchaseObj.wine.varietal && purchaseObj.wine.varietal.name) ? purchaseObj.wine.varietal.name + ' ' : '';
										var category = (purchaseObj.wine.category && purchaseObj.wine.category.name) ? purchaseObj.wine.category.name : '';
										var type = varietal + category;

										var purchasePriceFloat = purchaseObj.purchase.price;

										var valueGainFormatted = purchaseObj.wine.getRelativeGainPercentFormatted(purchasePriceFloat);
										var valueGainClass = purchaseObj.wine.getValueGainClass(purchasePriceFloat);

										var vineyard = (purchaseObj.wine.vineyard && purchaseObj.wine.vineyard.name) ? purchaseObj.wine.vineyard.name + ' > ' : '';

										purchasesThisMonth.push({
											name: purchaseObj.wine.getFullName(),
											appelation: vineyard + purchaseObj.wine.getFullAppellation(),
											type: type,
											size: purchaseObj.wine.bottleSize.name,
											qtyInCellar: purchaseObj.wine.cellar.qty,
											qtyPurchased: purchaseObj.purchase.qty,
											qtyOnOrder: purchaseObj.wine.getOnOrderQty(),
											purchasePrice: $window.numeral(purchasePriceFloat).format('$0,0[.]00'),
											value: $window.numeral(purchaseObj.wine.cellar.value).format('$0,0[.]00'),
											gain: valueGainFormatted,
											gainClass: valueGainClass
										});

										monthTotals.bottlesPurchased += purchaseObj.purchase.qty;
										monthTotals.cost += purchaseObj.purchase.qty * purchaseObj.purchase.price;
									});

									groupedByMonth.push({
										month: month,
										monthName: moment().getMonthNameFromInt(month),
										purchases: purchasesThisMonth,
										bottles: monthTotals.bottlesPurchased,
										cost: $window.numeral(monthTotals.cost).format('$0,0[.]00')
									});

									// update year totals from this month
									yearTotals.bottlesPurchased += monthTotals.bottlesPurchased;
									yearTotals.cost += monthTotals.cost;
								});

								self.report.groups.push({
									year: year,
									bottles: yearTotals.bottlesPurchased,
									cost: $window.numeral(yearTotals.cost).format('$0,0[.]00'),
									months: groupedByMonth
								});

								grandTotals.cost += yearTotals.cost;
								grandTotals.bottlesPurchased += yearTotals.bottlesPurchased;
							});
						} else {
							self.report.message = 'No purchases found for these dates';
						}

						self.report.totals = {
							'Years': grandTotals.yearCount,
							'Bottles': grandTotals.bottlesPurchased,
							'Cost': $window.numeral(grandTotals.cost).format('$0,0[.]00')
						};

						// hide loading
						self.report.loading = false;

						return true;
					}

					return false;

				}).catch(function(err){
					$log.debug('Error getting wines', err);
				});
		}

		function print(){
			return $window.print();
		}

		function updateDateRange() {
			// show loading
			self.report.loading = true;

			// reset groupings
			self.winesByYearMonth = {};
			self.report.groups = [];

			// reload all wines
			initialize();
		}
	}

})();
